/**
 * Clamp a numeric value between min and max, treating NaN/Infinity as min.
 */
export const clampNumber = (value: number, min: number, max: number) => {
  const safeValue = Number.isFinite(value) ? value : min;
  return Math.min(Math.max(safeValue, min), max);
};

/**
 * Floors a given number to the specified number of decimal places.
 *
 * @param {number} num - The number to be floored.
 * @param {number} [decimals=2] - The number of decimal places to floor to. Defaults to 2 if not provided.
 * @return {number} The floored number rounded down to the specified number of decimal places.
 */
export function floorToDecimals(num: number, decimals: number = 2): number {
  const factor = Math.pow(10, decimals);
  return Math.floor((num + Number.EPSILON) * factor) / factor;
}